<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 采购审批节点设置
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <el-form ref="workflowCompany" :inline="true" :model="workflowCompany">
        <el-form-item label="审批流程名称：" prop="workflowDefinitionName">
          <p>{{ workflowCompany.workflowDefinitionName }}</p>
        </el-form-item>
        <el-form-item label="审批节点信息：" prop="index">
          <p>第{{ workflowCompany.index }}审批节点</p>
        </el-form-item>
      </el-form>

      <!--表单添加-->
      <el-button
        type="primary"
        style="margin-bottom: 20px; float: right"
        @click="handleAddApprover"
        >新增审批人</el-button
      >
      <TableList :table-data="approverTableData" :table-label="tableLabel">
        <template #index="slot">
          {{ slot.scope.$index + 1 }}
        </template>
        <template #operation="slot">
          <el-button @click="handleDelete(slot.scope.$index)">删除</el-button>
        </template>
      </TableList>
      <add-approver-dialog
        v-if="addApproverDialogShow"
        :visible="addApproverDialogShow"
        :dialog-title="dialogTitle"
        :approver-table-data="approverData"
        @close="closeApproverDialog"
        @getData="getData"
      ></add-approver-dialog>

      <div style="margin-top: 20px; text-align: center">
        <el-button type="primary" @click="handleConfirm">确定添加</el-button>
        <el-button @click="handleCancle">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import TableList from '../../components/common/e-table-list';
import AddApproverDialog from '../../components/company/addApproverDialog';

export default {
  name: '',
  components: {
    AddApproverDialog,
    TableList,
  },
  props: {},
  data() {
    return {
      input: '',
      workflowCompany: {
        workflowDefinitionName: '',
        index: '',
      },
      approverTableData: [],
      approverData: [],
      tableLabel: [
        { label: '审批人', param: 'realName', align: 'center' },
        { label: '登录名', param: 'memberName', align: 'center' },
        // { label: "所属部门", param: "", align: "center" },
        { label: '联系方式', param: 'mobile', align: 'center' },
        { label: '操作', align: 'center', slot: 'operation' },
      ],
      addApproverDialogShow: false,
      dialogTitle: '',
    };
  },
  created() {
    this.workflowCompany.workflowDefinitionName = this.$getStore(
      'workflowDefinitionName'
    );
    this.workflowCompany.index = this.$getStore('index');
    this.getData();
  },
  methods: {
    // 新增审批人
    handleAddApprover() {
      this.addApproverDialogShow = true;
      this.approverData = this.approverTableData;
      this.dialogTitle = '新增审批人';
    },
    closeApproverDialog() {
      this.addApproverDialogShow = false;
    },
    getData(val) {
      let confirmWorkFlowSkusList = null;
      if (JSON.parse(this.$getStore('confirmWorkFlowSkusList'))) {
        confirmWorkFlowSkusList = JSON.parse(
          this.$getStore('confirmWorkFlowSkusList')
        );
      } else {
        confirmWorkFlowSkusList = val;
      }
      let resData = [];
      const workFlowSkusList =
        val || JSON.parse(this.$getStore('workFlowSkusList'));
      if (
        workFlowSkusList != null &&
        workFlowSkusList.approverList.length > 0
      ) {
        this.approverTableData = workFlowSkusList.approverList;
        return;
      }
      if (confirmWorkFlowSkusList) {
        for (let i = 0; i < confirmWorkFlowSkusList.length; i++) {
          if (
            this.workflowCompany.workflowDefinitionName ==
              confirmWorkFlowSkusList[i].workflowDefinitionName &&
            parseInt(confirmWorkFlowSkusList[i].level) ==
              parseInt(this.workflowCompany.index)
          ) {
            resData = resData.concat(confirmWorkFlowSkusList[i].approverList);
            this.approverTableData = resData;
            if (resData.length > 0) {
              const params = {
                workflowDefinitionName: this.$getStore(
                  'workflowDefinitionName'
                ),
                level: this.$getStore('index'),
                approverList: resData,
              };
              this.$setStore('workFlowSkusList', params);
            }
            break;
          }
        }
      }
      if (this.approverTableData.length == 0) {
        // this.approverTableData = JSON.parse(
        //   this.$getStore("confirmWorkFlowSkusList")
        // )[0].approverList;
      }
    },
    handleDelete(val) {
      this.approverTableData[val].isApprover = false;
      this.approverTableData.splice(val, 1);
      const workFlowSkusList = JSON.parse(this.$getStore('workFlowSkusList'));
      if (workFlowSkusList != null) {
        workFlowSkusList.approverList = this.approverTableData;
      }
      this.$setStore('workFlowSkusList', workFlowSkusList);
    },
    handleConfirm() {
      let confirmWorkFlowSkusList = JSON.parse(
        this.$getStore('confirmWorkFlowSkusList')
      );
      const workFlowSkusList = JSON.parse(this.$getStore('workFlowSkusList'));
      // let flag = false;
      if (this.approverTableData.length < 1) {
        return this.$message.warning('请添加审批人，请查看！');
      }
      if (
        workFlowSkusList != null &&
        parseInt(workFlowSkusList.level) ==
          parseInt(this.workflowCompany.index) &&
        workFlowSkusList.workflowDefinitionName ==
          this.workflowCompany.workflowDefinitionName
      ) {
        if (confirmWorkFlowSkusList == null) {
          confirmWorkFlowSkusList = [];
          confirmWorkFlowSkusList.push(workFlowSkusList);
        } else {
          let flag = false;
          confirmWorkFlowSkusList.forEach((sku) => {
            if (
              parseInt(workFlowSkusList.level) == parseInt(sku.level) &&
              workFlowSkusList.workflowDefinitionName ==
                sku.workflowDefinitionName
            ) {
              flag = true;
              sku.approverList = workFlowSkusList.approverList;
            }
          });
          if (flag == false) {
            confirmWorkFlowSkusList.push(workFlowSkusList);
          }
        }
      }
      this.$setStore('confirmWorkFlowSkusList', confirmWorkFlowSkusList);
      this.$setStore('createPurchaseAuditPath', { path: 'approverEdit' });
      this.$setStore('createName', this.$getStore('workflowDefinitionName'));
      this.removeStore();
      this.goToUrl();
    },
    handleCancle() {
      this.removeStore();
      this.goToUrl();
    },
    goToUrl() {
      this.$store.state.tagsList.map((item, index) => {
        if (item.fullPath == this.$route.path) {
          this.$store.state.tagsList.splice(index, 1);
        }
      });
      this.$router.go(-1);
    },
    removeStore() {
      this.$setStore('workFlowSkusList', null);
      this.$setStore('index', null);
    },
  },
};
</script>

<style scoped></style>
